// @flow
import React, { Fragment } from 'react';
import { Route } from 'react-router';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapRouteView from '../MapRouteView';
import MapStudentView from '../MapStudentView';
import MapMonitorView from '../MapMonitorView';
import MapParentView from '../MapParentView';
import BannerMessages from '../../TemporalBanner';
import Network from '../../NetworkListener';
import NetworkBanner from '../../NetworkBanner';
// import UserView from '../UserView';
import Map from '../../Map';

import styles from './mapView.css';


const MapView = () => (
  <Fragment>
    <Map offset={{ longitude: -0.4, latitude: 0.0 }} />
    <div className={styles.content}>
      <Route path="/admin/map/route/:id" component={MapRouteView} />
      <Route path="/admin/map/students/:id" component={MapStudentView} />
      <Route path="/admin/map/monitors/:id" component={MapMonitorView} />
      <Route path="/admin/map/parents/:id" component={MapParentView} />
      {/* <Route path="/admin/map/users" component={UserView} /> */}
    </div>
    <BannerMessages />
    <Network />
    <NetworkBanner />
  </Fragment>
);


export default MapView;



// WEBPACK FOOTER //
// ./src/scripts/components/views/MapView/index.jsx